module.exports = __webpack_public_path__ + "img/finance.05ec4567.png";